var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "1000",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Добавить') + " ")]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0"
  }, [_c('v-row', [_c('h3', {
    staticClass: "mb-2 ml-4 mt-6"
  }, [_vm._v("Выберите заявление")]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "card",
    attrs: {
      "elevation": 1
    }
  }, [_c('v-card-title', [_c('v-autocomplete', {
    attrs: {
      "label": "Протокол",
      "placeholder": "Выберите из списка",
      "items": _vm.protocolItems,
      "item-value": "id",
      "item-text": "protocolNumber",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "hide-no-data": "",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.getApplications
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function fn() {
        return [_c('div', {
          staticClass: "ml-4 mb-2"
        }, [_vm._v("Номер протокола / Дата протокола")]), _c('v-divider')];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(data) {
        var _data$item, _data$item2;

        return [_vm._v(" " + _vm._s((_data$item = data.item) === null || _data$item === void 0 ? void 0 : _data$item.protocolNumber) + " / " + _vm._s((_data$item2 = data.item) === null || _data$item2 === void 0 ? void 0 : _data$item2.protocolDate) + " ")];
      }
    }]),
    model: {
      value: _vm.filter.protocol,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "protocol", $$v);
      },
      expression: "filter.protocol"
    }
  }), _c('v-autocomplete', {
    staticClass: "ml-2",
    attrs: {
      "label": "Решение",
      "placeholder": "Выберите из списка",
      "items": _vm.decisionItems,
      "item-text": "name",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.getApplications
    },
    model: {
      value: _vm.filter.decision,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "decision", $$v);
      },
      expression: "filter.decision"
    }
  })], 1), _c('v-card-text', [_c('v-data-table', {
    staticClass: "table elevation-0",
    attrs: {
      "headers": _vm.tableHeaders,
      "loading": _vm.applicationLoading,
      "items": _vm.applicationItems.list,
      "search": _vm.applicationSearch,
      "items-per-page": -1,
      "height": 250,
      "dense": "",
      "hide-default-footer": "",
      "fixed-header": "",
      "no-results-text": "Нет подходящих заявлений"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var _vm$orderLine$applica;

        var item = _ref.item,
            index = _ref.index;
        return [_c('tr', {
          key: index,
          staticClass: "cursor-pointer",
          class: {
            selectedRow: ((_vm$orderLine$applica = _vm.orderLine.application) === null || _vm$orderLine$applica === void 0 ? void 0 : _vm$orderLine$applica.id) === item.id
          },
          on: {
            "click": function click($event) {
              return _vm.selectApplication(item);
            }
          }
        }, _vm._l(_vm.tableHeaders, function (header) {
          return _c('td', {
            staticClass: "text-start"
          }, [_vm._v(_vm._s(item[header.value]))]);
        }), 0)];
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('div', [_vm._v("Нет заявлений")])])], 2)], 1)], 1)], 1), _c('v-col', {
    staticClass: "py-0 mt-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Номер студента",
      "placeholder": "Введите номер студента",
      "outlined": "",
      "dense": "",
      "rounded": "",
      "error-messages": _vm.errorMessages.studentNumber
    },
    on: {
      "input": function input($event) {
        return _vm.$v.orderLine.studentNumber.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.orderLine.studentNumber.$touch();
      }
    },
    model: {
      value: _vm.orderLine.studentNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "studentNumber", $$v);
      },
      expression: "orderLine.studentNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Номер контракта",
      "placeholder": "Введите номер контракта",
      "outlined": "",
      "dense": "",
      "rounded": "",
      "error-messages": _vm.errorMessages.contractNumber
    },
    on: {
      "input": function input($event) {
        return _vm.$v.orderLine.contractNumber.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.orderLine.contractNumber.$touch();
      }
    },
    model: {
      value: _vm.orderLine.contractNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "contractNumber", $$v);
      },
      expression: "orderLine.contractNumber"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Группа",
      "placeholder": "Выберите из списка",
      "items": _vm.groupItems,
      "item-text": "name",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.group
    },
    on: {
      "input": function input($event) {
        return _vm.$v.orderLine.group.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.orderLine.group.$touch();
      }
    },
    model: {
      value: _vm.orderLine.group,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "group", $$v);
      },
      expression: "orderLine.group"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('UIDatePicker', {
    attrs: {
      "label": "Дата контракта",
      "error-messages": _vm.errorMessages.contractDate
    },
    on: {
      "input": function input($event) {
        return _vm.$v.orderLine.contractDate.$touch();
      }
    },
    model: {
      value: _vm.orderLine.contractDate,
      callback: function callback($$v) {
        _vm.$set(_vm.orderLine, "contractDate", $$v);
      },
      expression: "orderLine.contractDate"
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s(_vm.isShowMode ? 'Закрыть' : 'Отмена') + " ")]), !_vm.isShowMode ? _c('v-btn', {
    attrs: {
      "loading": _vm.saveBtnLoading,
      "disabled": _vm.$v.$invalid || _vm.isShowMode,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveOrderLine
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }